import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubble-check, comment, feedback"} maskId="square-filled-radius-0-stroke-1-IconBubbleCheck"><path fillRule="evenodd" clipRule="evenodd" d="M3 3L21 3.00002V19H15.1957L11.996 21.6509L8.83366 19L3 19V3ZM15.9071 8.90002L15.2 8.19292L11 12.3929L9.19997 10.5929L8.49286 11.3L11 13.8071L15.9071 8.90002Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubbleCheck;
